<form [formGroup]="form">
  <div class="column-2">
    <div class="col">
      <div class="input-container">
        <label>
          Bill To Name
          <mat-icon-button
            mat-icon-button
            class="btn-hint"
            matTooltip="This is the party to whom disposal costs will be charged"
          >
            <mat-icon class="help-icon">help</mat-icon>
          </mat-icon-button>
        </label>
        <mat-form-field appearance="outline">
          <input
            maxlength="64"
            matInput
            formControlName="name"
            [tabIndex]="tabIndex"
          />
          <mat-error *ngIf="errorHandling('name', 'required')">
            Bill To Name is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col">
      <div class="input-container" formGroupName="contact">
        <label> Contact Name </label>
        <mat-form-field appearance="outline">
          <input
            maxlength="64"
            matInput
            formControlName="name"
            [tabIndex]="tabIndex + 1"
          />
          <mat-error *ngIf="errorHandlingContact('name', 'required')">
            Contact Name is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="column-2" formGroupName="contact">
    <div class="col">
      <div class="input-container">
        <label>Billing Contact Phone </label>
        <mat-form-field appearance="outline" floatLabel="always">
          <input
            formControlName="phone"
            matInput
            digitalPlatformPhoneFormat
            placeholder="_ _ _ - _ _ _ - _ _ _ _"
            [tabIndex]="tabIndex + 2"
          />
          <mat-error *ngIf="errorHandlingContact('phone', 'required')">
            Billing Contact Phone is <strong>Required</strong>
          </mat-error>
          <mat-error
            class="error"
            *ngIf="errorHandlingContact('phone', 'pattern')"
          >
            Phone Number Format Must be a ___-___-____
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="col">
      <div class="input-container">
        <label>Billing Contact Email </label>
        <mat-form-field appearance="outline" floatLabel="always">
          <input matInput formControlName="email" [tabIndex]="tabIndex + 3" />
          <mat-error *ngIf="errorHandlingContact('email', 'required')">
            Billing Contact Email is <strong>Required</strong>
          </mat-error>
          <mat-error *ngIf="errorHandlingContact('email', 'email')">
            Please enter a valid Email Address
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div>
    <digital-platform-address-input
      label="Bill To Address"
      formControlName="address"
      [required]="isAddressRequired"
      [tabIndex]="tabIndex + 4"
      [countyRequired]="isAddressRequired"
      [profileStatus]="profileStatus"
      [isLegacy]="isLegacy"
    ></digital-platform-address-input>
  </div>

  <div class="column-2">
    <div class="col">
      <div class="input-container">
        <label> Additional Comments (optional) </label>
        <mat-form-field appearance="outline">
          <textarea
            maxlength="48"
            formControlName="notes"
            matInput
            matTextareaAutosize
            matAutosizeMinRows="3"
            matAutosizeMaxRows="3"
            [tabIndex]="tabIndex + 11"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="col"></div>
  </div>
</form>
